<script setup lang="ts">
import { GENDER } from "~/constants";

interface IconGenderProps {
  fill?: string;
  gender: TGender;
  size?: number;
}
const props = withDefaults(defineProps<IconGenderProps>(), {
  fill: "var(--base-secondary-color)",
  size: 12,
});
</script>

<template>
  <div class="flex items-center justify-center bg-[var(--base-background-color)] rounded-full p-[3px]">
    <svg
      v-if="props.gender === GENDER.MALE"
      :width="props.size"
      :height="props.size"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.734 1.125v1.031h1.38L7.7 3.572a4.084 4.084 0 0 0-5.38.341A4.081 4.081 0 0 0 2.32 9.68a4.083 4.083 0 0 0 5.766 0 4.084 4.084 0 0 0 .341-5.38l1.417-1.415v1.38h1.031v-3.14h-3.14zm-.377 7.826a3.05 3.05 0 0 1-4.308 0 3.05 3.05 0 0 1 0-4.309 3.05 3.05 0 0 1 4.309 0 3.05 3.05 0 0 1 0 4.31z"
        :fill="props.fill"
        fill-rule="nonzero"
      />
    </svg>

    <svg
      v-else-if="props.gender === GENDER.FEMALE"
      :width="props.size"
      :height="props.size"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.078 4.453A4.083 4.083 0 0 0 6 .375a4.083 4.083 0 0 0-4.078 4.078A4.084 4.084 0 0 0 5.484 8.5v.735H4.125v1.032h1.36v1.359h1.03v-1.36h1.36v-1.03h-1.36v-.736a4.084 4.084 0 0 0 3.563-4.046zm-7.125 0A3.05 3.05 0 0 1 6 1.406a3.05 3.05 0 0 1 3.047 3.047A3.05 3.05 0 0 1 6 7.5a3.05 3.05 0 0 1-3.047-3.047z"
        :fill="props.fill"
        fill-rule="nonzero"
      />
    </svg>

    <svg
      v-else-if="props.gender === GENDER.MIXED"
      :width="props.size"
      :height="props.size"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.805.38v1.031H8.81l-.87.87A3.696 3.696 0 0 0 5.134.989 3.707 3.707 0 0 0 1.43 4.693 3.709 3.709 0 0 0 4.618 8.36v.88H3.446v1.03h1.171v1.36H5.65v-1.36H6.82V9.24H5.649v-.88a3.709 3.709 0 0 0 3.187-3.667c0-.525-.111-1.044-.328-1.522L9.54 2.139v1.007h1.032V.38H7.805zM5.133 7.364a2.672 2.672 0 1 1 0-5.344 2.672 2.672 0 0 1 0 5.344z"
        :fill="props.fill"
        fill-rule="nonzero"
      />
    </svg>
  </div>
</template>
